import React, { useState } from "react";
import {
	Accordion as MuiAccordion,
	AccordionSummary,
	AccordionDetails,
	Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from '@mui/icons-material/Remove';

const Accordion = ({ summary, children }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	return (
		<MuiAccordion square onChange={() => setIsExpanded(prev => !prev)}>
			<AccordionSummary
				sx={{
					backgroundColor: "secondary.main",
				}}
				expandIcon={isExpanded ? <RemoveIcon  sx={{ color: "common.white" }}/> : <AddIcon sx={{ color: "common.white" }}/>}
			>
				<Typography sx={{ flexGrow: "1", color: "common.white" }}>
					{summary}
				</Typography>
			</AccordionSummary>
			<AccordionDetails sx={{ backgroundColor: "secondary.extra_light" }}>
				{children}
			</AccordionDetails>
		</MuiAccordion>
	);
};

export default Accordion;
